import { topics } from "@/mocks/melon";

function Topics() {
  return (
    <section id="topic" className="scroll-mt-24 bg-background-100/60">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-primary-600">In-depth</p>
            <h2 className="mt-2 font-heading text-2xl font-extrabold tracking-tight text-foreground-950 md:text-4xl">
              深度专题 · 不止于瓜
            </h2>
            <p className="mt-3 max-w-2xl text-sm text-foreground-600 md:text-base">
              瓜吃多了，也想弄明白为什么。把现象放回更大的语境里，聊点更有营养的。
            </p>
          </div>
          <a
            href="#faq"
            className="inline-flex h-10 shrink-0 items-center gap-1.5 rounded-md border border-background-300 bg-background-50 px-4 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 whitespace-nowrap"
          >
            有问题先看 FAQ <i className="ri-arrow-right-line text-[14px]" />
          </a>
        </div>

        <div className="mt-9 flex flex-col gap-7">
          {topics.map((t, i) => (
            <article
              key={t.id}
              className={`group grid grid-cols-1 items-stretch overflow-hidden rounded-2xl border border-background-200 bg-background-50 lg:grid-cols-2 ${
                i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
              }`}
            >
              <div className="relative h-52 overflow-hidden sm:h-64 lg:h-auto lg:min-h-[300px]">
                <img
                  src={t.img}
                  alt={t.alt}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-4 top-4 rounded-md bg-accent-500 px-2.5 py-1 text-xs font-bold text-foreground-950">
                  {t.kicker}
                </span>
              </div>
              <div className="flex flex-col justify-center p-6 md:p-9">
                <div className="flex items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded bg-background-100 px-2 py-1">
                    <i className="ri-book-open-line text-primary-600" />
                    专题报道
                  </span>
                  <span>约 {t.readTime} 阅读</span>
                </div>
                <h3 className="mt-4 font-heading text-xl font-extrabold leading-snug tracking-tight text-foreground-950 md:text-2xl">
                  {t.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">{t.excerpt}</p>
                <a
                  href="#guide"
                  className="mt-5 inline-flex w-fit items-center gap-1.5 text-sm font-semibold text-primary-600 transition-colors hover:text-primary-700"
                >
                  继续阅读 <i className="ri-arrow-right-line text-[15px]" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Topics;